export default "__VITE_ASSET__DEoY7h7b__"